module.exports = [
  {
    image: '/images/icon-awards/01.svg',
    content: {
      zh: [
        '2008年獲澳門特區政府頒授旅遊功績勳章',
      ],
      en: [
        'Medal of Merit for Tourism',
        '2008',
        'Macao SAR Government',
      ],
    },
  },
  {
    image: '/images/icon-awards/02.svg',
    content: {
      zh: [
        '自2000年至今共有八個學士學位課程獲聯合國世界旅遊組織頒發“旅遊教育質素認證”',
      ],
      en: [
        'UNWTO.TedQual Certification for Eight IFT Bachelor’s degree programmes',
        'from 2000',
        'UNWTO.Themis Foundation',
      ],
    },
  },
  {
    image: '/images/icon-awards/03.svg',
    content: {
      zh: [
        '2017年成功通過英國高等教育質素保證機構（QAA）的“國際質素評鑑”',
      ],
      en: [
        'International Quality Review',
        '2017',
        'UK’s Quality Assurance Agency for Higher Education (QAA)',
      ],
    },
  },
  {
    image: '/images/icon-awards/04.svg',
    content: {
      zh: [
        '先後於1997年及2002年獲亞太旅遊協會頒授“教育及培訓”金獎',
      ],
      en: [
        'Gold Award in Education and Training',
        '1997 and 2002',
        'Pacific Asia Travel Association (PATA)',
      ],
    },
  },
  {
    image: '/images/icon-awards/01.svg',
    content: {
      zh: [
        '先後於2014年及2015年獲得由力報主辦、澳門廣播電視股份有限公司合辦的“澳門優質服務品牌選舉 — 最優質教育文化業品牌”獎項',
      ],
      en: [
        'Best Educational Organisation – Service and Brand: Macau Elite Service Award',
        '2014 and 2015',
        'Exmoo News and TDM',
      ],
    },
  },
  {
    image: '/images/icon-awards/02.svg',
    content: {
      zh: [
        '成功取得國際標準化組織發出的ISO 20000資訊科技服務管理認證',
      ],
      en: [
        'ISO 20000 IT Service Management System Certification',
        'International Organization for Standardization',
      ],
    },
  },
  {
    image: '/images/icon-awards/03.svg',
    content: {
      zh: [
        '成功取得國際標準化組織發出的ISO 14001:2015環境管理體系認證',
      ],
      en: [
        'ISO 14001:2015 Environmental Management System Certification',
        'International Organization for Standardization',
      ],
    },
  },
  {
    image: '/images/icon-awards/04.svg',
    content: {
      zh: [
        '望廈迎賓館獲澳門環境保護局頒發“澳門環保酒店獎金獎”（有效期至2019年）',
      ],
      en: [
        'Macao Green Hotel Gold Award, for the Pousada de Mong-Há',
        'Valid until 2019',
        'Macao Environmental Protection Bureau',
      ],
    },
  },
  {
    image: '/images/icon-awards/01.svg',
    content: {
      zh: [
        '望廈迎賓館及旅遊學院教學餐廳於2009年至2018年期間，連續每年獲《米芝蓮指南香港澳門》推介',
      ],
      en: [
        'Recommended Hotel and Restaurant ratings, respectively for the Pousada de Mong-Há and the Educational Restaurant',
        '2009 to 2018',
        'Michelin Guide Hong Kong and Macau',
      ],
    },
  },
  {
    image: '/images/icon-awards/02.svg',
    content: {
      zh: [
        '望廈迎賓館於2011年至2018年期間，連續每年獲國際知名旅遊網站TripAdvisor頒發“旅行者最佳之選”獎項',
      ],
      en: [
        'Travellers’ Choice Award, for the Pousada de Mong-Há',
        '2011 to 2018',
        'TripAdvisor',
      ],
    },
  },
  {
    image: '/images/icon-awards/03.svg',
    content: {
      zh: [
        '望廈迎賓館及旅遊學院教學餐廳於2015年至2018年期間，連續每年獲國際知名旅遊網站TripAdvisor 頒發“卓越獎”',
      ],
      en: [
        'Certificate of Excellence, for the Pousada de Mong-Há and the IFT Educational Restaurant',
        '2015 to 2018',
        'TripAdvisor',
      ],
    },
  },
  {
    image: '/images/icon-awards/04.svg',
    content: {
      zh: [
        '望廈迎賓館於2018年獲TripAdvisor頒發“中國最具性價比酒店”第二位',
      ],
      en: [
        'Top 2 Bargain Hotels in China for the Pousada de Mong-Há',
        '2018',
        'TripAdvisor',
      ],
    },
  },
  {
    image: '/images/icon-awards/01.svg',
    content: {
      zh: [
        '2016年獲De Ficção Multimedia Projects及澳門商務讀者慈善會頒發“澳門商務大獎卓越優異大獎”',
      ],
      en: [
        'Grand Merit Award: Business Awards of Macau',
        '2016',
        'De Ficção Multimedia Projects and Charity Association of Macau Business Readers',
      ],
    },
  },
]
